<template>
    <div class="setup-account">
        <div class="security-question">
            <div class="setup">
                <div v-if="!expired && !broken">
                    <h3>Link verified</h3>
                    <p><a :href=link>Continue</a> to your dashboard</p>
                </div>
                <div v-if="expired && !broken" class="expired">
                    <p>
                        <router-link to="/login"><img src="../../public/logo-small.png" /></router-link>
                    </p>
                    <p>Sorry, link has expired</p>
                </div>
                <div v-if="!expired && broken" class="broken">
                    <p>
                        <router-link to="/login"><img src="../../public/logo-small.png" /></router-link>
                    </p>
                    <p>Sorry, link has broken or doesn't exist</p>
                </div>
            </div>
        </div>
        <loading ref="loading"></loading>
        <notify ref="notify"></notify>
    </div>
</template>
<style scoped>
    .expired {
        width: 400px;
    }
    .expired p {
        font-size: 14px;
        margin-bottom: 0;
    }
    .broken {
        width: 400px;
    }
    .broken p {
        font-size: 14px;
        margin-bottom: 0;
    }
    .security-question .setup .form div {
        margin-bottom: 0;
    }
    .setup-account {
        height: 100%;
    }
    .security-question {
        height: 100%;
    }
    .question {
        margin-bottom: 1em !important;
    }
    .question label {
        font-weight: normal !important;
        margin-bottom: 0 !important;
    }
</style>

<script>
import loading from '@/components/Loading'
import notify from '@/components/Notify'
import AuthenticationService from '../services/AuthenticationService'
export default {
  components: {
    loading,
    notify
  },
  data () {
    return {
      error: {
        answer: false
      },
      broken: false,
      expired: false,
      link: ''
    }
  },
  mounted () {
    let that = this
    this.$refs.loading.load()
    AuthenticationService.verify_email_link({ link: this.$route.params.link }).then((response) => {
      if (response.data.found) {
        if (response.data.expire === true) {
          that.$refs.loading.close()
          that.broke = false
          that.expired = true
        } else {
          that.$refs.loading.close()
          window.location = response.data.link
        }
      } else {
        that.$refs.loading.close()
        that.broken = true
        that.expired = false
      }
    }).catch((error) => {
      return console.log(error)
    })
  }
}
</script>
